import { Spin } from 'antd';
import { getTrendIcon } from '../../dashboard/components/AdminDashboardMetrics';
import React from 'react';

function StatsCard({
  title,
  value,
  trend,
  icon,
  invertColours = false,
  loading = false,
  size= 'large'
}) {
  return (
    <div
      key={title}
      className='event_admin-dashboard-metrics__card justify-between'
    >
      <div>
        <p className={`gMedium ${size === 'large' ? 'fs-20' : 'fs-18'} mg-bottom-0 cap`}>{title}</p>
        {loading ? (
          <div className='txt-left w-full'>
            <Spin className={size === 'large' ? 'fs-40' : 'fs-32'} />
          </div>
        ) : (
          <span className={`gMedium lh-1.1 ${size === 'large' ? 'fs-40' : 'fs-32'} mg-bottom-0 row-center`}>
            {value ?? ''}
            <span className={`${size === 'large' ? 'fs-22' : 'fs-18'} mg-left-5 grid-center admin-dashboard-metrics__trend`}>
              {getTrendIcon(trend, invertColours)}
            </span>
          </span>
        )}
      </div>
      <div className='admin-dashboard-metrics__icon sb-blue-100 sb-blue-bg-700'>
        {icon}
      </div>
    </div>
  );
}

export default StatsCard;
